import React from 'react';
import * as S from './styles';
import { CardContentsProps } from './types';

/**
 * Used to wrap Card's `children` in order to provide the correct layout
 */
export default function CardContents<As extends React.ElementType = 'div'>({
  as,
  children,
  ...props
}: CardContentsProps<As>) {
  const Component = as ?? 'div';

  return (
    <S.Root as={Component} {...props}>
      {children}
    </S.Root>
  );
}
